import { Timestamp } from "rxjs/operators/timestamp";

export interface FlashProduct {
    ProductCode: number;
    Name: string;
    Enabled: boolean;
    Min: number;
    Max: number;
    Vendor: string;
    ProductGroupId: number;
    DateSyncedUtc: string;
    ProductImageId: string | null;
    Description: string | null;
}

export class FlashProduct {
    productCode: number;
    name: string;
    enabled: boolean;
    min: number;
    max: number;
    vendor: string;
    productGroupId: number;
    dateSyncedUtc: Date;
    productImageId: string | null;
    description: string | null;
    constructor(item?: FlashProduct) {
        this.productCode = item.ProductCode;
        this.name = item.Name;
        this.enabled = item.Enabled;
        this.min = item.Min;
        this.max = item.Max;
        this.vendor = item.Vendor;
        this.productGroupId = item.ProductGroupId;
        this.productImageId = item.ProductImageId;
        this.description = item.Description || "";
        this.dateSyncedUtc = item && new Date(item.DateSyncedUtc + "Z");
    }
}

export class EditFlashProductModel {
    productCode: number;
    name: string;
    enabled: boolean;
    min: number;
    max: number;
    vendor: string;
    productGroupId: number;
    productImageId: string | null;
    description: string | null;
}


// Flash Product group
export interface FlashProductGroup {
    Id: number;
    Name: string;
    Description: string | null;
    ApiPath: string;
    Enabled: boolean;
    ProductGroupImageId: string | null;
}

export class FlashProductGroup {
    id: number;
    name: string;
    description: string | null;
    apiPath: string;
    enabled: boolean;
    productGroupImageId: string | null;

    constructor(item?: FlashProductGroup) {
        this.id = item.Id;
        this.name = item.Name;
        this.description = item.Description;
        this.apiPath = item.ApiPath;
        this.enabled = item.Enabled;
        this.productGroupImageId = item.ProductGroupImageId;
    }
}

export class EditFlashProductGroupModel {
    id: number;
    name: string;
    description: string | null;
    enabled: boolean;
    productGroupImageId: string | null;
}





// WEBPACK FOOTER //
// ./src/app/models/inModels/Flash.ts